// jshint module: true

// Enable OS classnames (is-osx, is-windows)
if (navigator.userAgent.match(/(Mac OS X)/gi)) {
  document.body.classList.add('is-osx');
} else if (navigator.userAgent.match(/(Windows)/gi)) {
  document.body.classList.add('is-windows');
}
var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
if (iOS) {
  document.body.classList.add('is-ios');
}



// WEBPACK FOOTER //
// ./bluemountain/assets/scripts/vendor/fabrique/polyfills/enable-os-classnames.js